export default __webpack_public_path__ + "static/media/ic_saba_island.9d23a0f0.svg";